<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { cardActions } from "@/action/cardActions";
import ActionMenuDropdown from "@/components/ActionMenu/ActionMenuDropdown.vue";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { boardKey } from "@/components/board/injectKeys";
import TypeDot from "@/components/ui/TypeDot/TypeDot.vue";
import { boardTypeName } from "@/model/baseTypes";
import { isDependency } from "@/model/stickyType";
import { injectStrict } from "@/utils/vue";

import StickyTypeChange from "./StickyTypeChange.vue";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);

const { t } = useI18n();
const disabledMessage = computed(() => {
  if (isDependency(card)) {
    return t("stickyNote.changeTypeDependencyNotAllowed");
  }
  if (card.type.origin !== board.value.type) {
    return t("stickyNote.changeTypeOnlyOriginBoard", { board: t(boardTypeName(card.type.origin)) });
  }
  return "";
});
</script>

<template>
  <ActionMenuDropdown
    :action="cardActions.setType"
    :tooltip="disabledMessage"
    :disabled="!!disabledMessage"
  >
    <template #content>
      <TypeDot :color="card.type.color" size="medium" />
    </template>
    <StickyTypeChange :header="$t('stickyNote.stickyType')" />
  </ActionMenuDropdown>
</template>
